/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { GoldenTransferResolveDto } from './goldenTransferResolveDto';

/**
 * Transfers from golden project
 */
export interface GoldenTransferDto {
  id: number;
  asset: string;
  network: string;
  contract: string;
  fromAddress: string;
  fromLabel?: string;
  toAddress: string;
  toLabel?: string;
  txHash: string;
  quantity: number;
  time: string;
  status: GoldenTransferDto.StatusEnum;
  comment: string;
  direction: GoldenTransferDto.DirectionEnum;
  account?: Account;
  requestAdminId?: number;
  approveAdminId?: number;
  networkFee?: number;
  networkFeeAsset?: string;
  networkFeeInUsd?: number;
  businessEntity: GoldenTransferDto.BusinessEntityEnum;
  resolveMetadata?: GoldenTransferResolveDto;
}
export namespace GoldenTransferDto {
  export const StatusEnum = {
    Pending: 'PENDING',
    Error: 'ERROR',
    Settled: 'SETTLED',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
  export const DirectionEnum = {
    Deposit: 'DEPOSIT',
    Withdraw: 'WITHDRAW',
    Internal: 'INTERNAL',
    DepositRebate: 'DEPOSIT_REBATE',
    WithdrawRebate: 'WITHDRAW_REBATE',
    InternalDeposit: 'INTERNAL_DEPOSIT',
    InternalWithdraw: 'INTERNAL_WITHDRAW',
  } as const;
  export type DirectionEnum = (typeof DirectionEnum)[keyof typeof DirectionEnum];
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
